import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

import { Auth } from '@/api/models';
import { state, actions } from '@/store';

import User from '../api/models/users/User';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes(authGuard, guestGuard)
});

export default router;

const whiteList = ['login', 'home']



router.beforeEach(async (to, from, next) => {
    try {
        const user = await Auth.me();
        actions.setUser(user.data);
    } catch(error) {
        actions.resetAuth();
    }

    let userDashboards = []
    state.user ? userDashboards = state.user.dashboards : null

    const userRoutes = [...whiteList , ...userDashboards];
    if(!userRoutes.includes(to.name) && to.name !== 'home'){
        return next({ name: 'home'});
    }

    next();
});

function beforeEnter (routes, callback) {
    return routes.map(route => {
        return { ...route, beforeEnter: callback };
    });
};

function authGuard (routes) {
    return beforeEnter(routes, (to, from, next) => {
        if (!state.token) {
            return next({ name: 'login' });
        }

        next();
    });
};

function guestGuard (routes) {
    return beforeEnter(routes, (to, from, next) => {
        if (state.token) {
            return next({ name: 'home' });
        }

        next();
    });
};